import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Button, Checkbox, Divider, FormControl, IconButton, Input, List, ListItem, ListItemIcon, ListItemText, Paper, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { setShowWellListFilter } from '../reducers/optionsSlice';
import { selectLists, setListFilters } from '../reducers/listSlice';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'absolute',
    backgroundColor: 'white',
    right: 0,
    top: 0,
    width: 300,
    height: '100vh',
    overflowY: 'auto',
    // padding: 10,
    paddingTop: 80,
    zIndex: 666,
    borderRadius: 0
    // paddingBottom: 140
  },
  heading: {
    marginBottom: 20,
    fontSize: 18
  },
  header: {
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    position: 'fixed', 
    backgroundColor: 'white',
    top: 60, 
    width: 300, 
    height: 50,
    padding: 10,
    borderBottom: '1px solid lightgrey',
    zIndex: 70
  },
  footer: {
    display: 'flex',
    backgroundColor: 'white',
    justifyContent: 'center', 
    alignItems: 'center', 
    position: 'fixed',
    paddingTop: 30,
    paddingBottom: 30,
    bottom: 0, 
    width: 300, 
    height: 40,
    borderTop: '1px solid lightgrey',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
  },
  toggleButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 10
  },
  cutoff: {
    padding: '0 10px'
  },
  addSegmentButton: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    margin: '10px 0'
  },
  segment: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'transparent',
  },
  emptyForecast: {
    height: 'calc(100% - 120px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  list: {
    minHeight: 120,
    maxHeight: 600,
    borderRadius: 5,
    border: '1px solid lightgrey',
    backgroundColor: theme.palette.grey[100],
    overflow: 'auto'
  },
  listItem: {
    margin: 0,
    padding: 0,
  }
}));

export const FilterWellList = ({ listId, wells }) => {

  const classes = useStyles();
  const dispatch = useDispatch();

  const lists = useSelector(selectLists);
  const filters = lists.byId[listId]?.filters;
  
  const [dateFrom, setDateFrom] = useState(filters?.dateFrom ? filters?.dateFrom : "");
  const [dateTo, setDateTo] = useState(filters?.dateTo ? filters?.dateTo : "");
  const [producingFluid, setProducingFluid] = useState(filters?.symbol ? filters?.symbol : []);
  const [trajectory, setTrajectory] = useState(filters?.trajectory ? filters.trajectory : []);
  const [licensees, setLicensees] = useState(filters?.licensee ? filters.licensee : []);
  const [fieldNames, setFieldNames] = useState(filters?.field_name ? filters?.field_name : []);
  const [poolNames, setPoolNames] = useState(filters?.pool_name ? filters?.pool_name : []);
  const [producingFormations, setProducingFormations] = useState(filters?.producing_formation ? filters?.producing_formation : []);
  const [status, setStatus] = useState(filters?.status ? filters?.status : []);


  const customList = (parameter, setParameter, items) => (
    <List
      dense
      component="div"
      role="list"
      className={classes.list}
    >
      {items?.length > 0 && items[0]?.length > 0 && Array.from(new Set(items.filter(i => i?.length > 0))).map((value) => {
        return (
          <ListItem
            key={value}
            role="listitem"
            button
            className={classes.listItem}
            onClick={e => {}}
          >
            <ListItemIcon>
              <Checkbox
                checked={parameter.indexOf(value) !== -1}
                tabIndex={-1}
                disableRipple
                color="primary"
                onClick={() => handleCheckToggle(parameter, value, setParameter)}
              />
            </ListItemIcon>
            <ListItemText primary={value} style={{fontSize: 10}} />
          </ListItem>
        );
      })}
      <ListItem />
    </List>
  );

  function handleCheckToggle(parameter, value, setValue) {
    if (parameter.indexOf(value) === -1) {
      setValue([...parameter, value]);
    } else {
      setValue([...parameter.filter(p => p !== value)]);
    };
  };

  return (
    <Paper className={classes.root} elevation={3}>
      <div className={classes.header}>
        <Typography>FILTERS</Typography>
        <IconButton onClick={() => dispatch(setShowWellListFilter(false))}><Close /></IconButton>
      </div>
      <Divider style={{width: '100%'}} />

      <div style={{height: 'auto', overflow: 'hidden', padding: 10, paddingTop: 20, paddingBottom: 80}}>

        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 20}}>ON PRODUCTION DATE (FROM)</Typography>
        <FormControl variant="filled" style={{width: '100%'}}>
          <Input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)} />
        </FormControl>

        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 20}}>ON PRODUCTION DATE (TO)</Typography>
        <FormControl variant="filled" style={{width: '100%'}}>
          <Input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)} />
        </FormControl>

        {/* <Typography color='textSecondary' style={{fontSize: 12, marginTop: 20}}>PRODUCING FLUID</Typography>
        <FormControl variant="filled" style={{width: '100%'}}>
          <Select 
            label="Fluid"
            value={producingFluid} 
            onChange={e => setProducingFluid(e.target.value)}
            style={{width: '100%'}}
          >
            {['any', 'oil', 'gas', 'condensate']?.map(c => {
              return (
                <MenuItem value={c} key={c}>{c.charAt(0).toUpperCase()+c.slice(1,)}</MenuItem>
              )
            })}
          </Select>
        </FormControl> */}

        {/* <Typography color='textSecondary' style={{fontSize: 12, marginTop: 20}}>TRAJECTORY</Typography>
        <FormControl variant="filled" style={{width: '100%'}}>
            <Select 
              label="Trajectory"
              value={trajectory} 
              onChange={e => setTrajectory(e.target.value)}
              style={{width: '100%'}}
            >
              {['any', 'vertical', 'directional', 'horizontal', 'slant']?.map(c => {
                return (
                  <MenuItem value={c} key={c}>{c.charAt(0).toUpperCase()+c.slice(1,)}</MenuItem>
                )
              })}
            </Select>
          </FormControl> */}

        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 10}}>PRODUCING FLUID</Typography>
        {producingFluid && customList(producingFluid, setProducingFluid, getParameterValues('producingFluid', wells))}
        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 10}}>STATUS</Typography>
        {status && customList(status, setStatus, getParameterValues('status', wells))}
        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 10}}>LICENSEE</Typography>
        {licensees && customList(licensees, setLicensees, getParameterValues('licensee', wells))}
        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 10}}>TRAJECTORY</Typography>
        {trajectory && customList(trajectory, setTrajectory, getParameterValues('trajectory', wells))}
        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 10}}>FIELD NAME</Typography>
        {fieldNames && customList(fieldNames, setFieldNames, getParameterValues('field_name', wells))}
        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 10}}>POOL NAME</Typography>
        {poolNames && customList(poolNames, setPoolNames, getParameterValues('pool_name', wells))}
        <Typography color='textSecondary' style={{fontSize: 12, marginTop: 10}}>PRODUCING FORMATION</Typography>
        {producingFormations && customList(producingFormations, setProducingFormations, getParameterValues('producing_formation', wells))}
      </div>

      <Divider style={{width: '100%'}} />

      <div className={classes.footer}>
        <Button variant="outlined" color="primary" style={{marginRight: 20}} onClick={clearFilters}>Clear</Button>
        <Button variant="contained" color="primary" style={{marginLeft: 20}} onClick={applyFilters}>Apply</Button>
      </div>

    </Paper>
  );

  function applyFilters() {
    const filters = {};
    if (dateFrom?.length > 0) filters.dateFrom = dateFrom;
    if (dateTo?.length > 0) filters.dateTo = dateTo;
    // if (producingFluid === 'any') {
    //   setProducingFluid("");
    //   delete filters.symbol;
    // } else if (producingFluid?.length > 0) {
    //   filters.symbol = producingFluid;
    // };
    // if (trajectory === 'any') {
    //   delete filters.trajectory;
    //   setTrajectory("");
    // } else if (trajectory?.length > 0) {
    //   filters.trajectory = trajectory;
    // };
    if (producingFluid?.length > 0) filters.producingFluid = producingFluid;
    if (licensees?.length > 0) filters.licensee = licensees;
    if (trajectory?.length > 0) filters.trajectory = trajectory;
    if (fieldNames?.length > 0) filters.field_name = fieldNames;
    if (poolNames?.length > 0) filters.pool_name = poolNames;
    if (producingFormations?.length > 0) filters.producing_formation = producingFormations;
    if (status?.length > 0) filters.status = status;

    dispatch(setListFilters({listId: listId, filters: filters}));
  };
  
  function clearFilters() {
    setDateFrom("");
    setDateTo("");
    setProducingFluid([]);
    setTrajectory([]);
    setLicensees([]);
    setFieldNames([]);
    setPoolNames([]);
    setProducingFormations([]);
    setStatus([]);
    dispatch(setListFilters({listId: listId, filters: {}}));
  };

  function getParameterValues(parameter, wells) {
    try {
      if (parameter === 'status') {
        let statuses = [];
        wells.forEach(well => {
          if (statuses.indexOf(well.status.toUpperCase()) === -1) statuses.push(well.status.toUpperCase());
        });
        return statuses;
      };
      if (parameter === 'producingFluid') {
        let producingFluid = [];
        wells.forEach(well => {
          well.production?.fluids.forEach(fluid => {
            if (producingFluid.indexOf(fluid) === -1) producingFluid.push(fluid);
          });
        });
        // return producingFluid;
        return ['Oil', 'Gas', 'Condensate', 'Water'];
      };
      let values = [];
      wells.forEach(well => {
        if (well.status === 'processed' && well.details[parameter]) {
          values.push(well.details[parameter]);
        };
      });
      return values;
    } catch (error) {
      return null;
    };
  };
  
};
